<template>
  <div class="d-flex flex-column gap-3 pa-6 pb-3">
    <div class="d-flex flex-column justify-center align-center">
      <v-icon size="50" class="mb-2">mdi-ticket-percent</v-icon>
      <h4>Benefício de Meia Entrada</h4>
    </div>

    <template v-if="error">
      <v-alert type="error" text>
        {{ error }}
      </v-alert>
      <v-btn block text to="/" small> Voltar para o início </v-btn>
    </template>
    <v-skeleton-loader type="paragraph" v-else-if="loading" />
    <v-card outlined v-else class="pa-4" rounded="lg">
      <h5>{{ state.title }}</h5>
      <p>{{ state.description }}</p>

      <div class="d-flex flex-column gap-2">
        <v-btn
          v-if="state.canApply"
          block
          depressed
          color="success"
          @click="$emit('showForm')"
        >
          Solicitar benefício
        </v-btn>
        <v-btn
          v-if="state.canViewRequest"
          block
          color="primary"
          depressed
          @click="$emit('showModal')"
        >
          Ver solicitação
        </v-btn>
        <v-btn v-if="state.canRevoke" @click="$emit('cancelRequest')" block color="warning" text small>
          Cancelar solicitação
        </v-btn>
      </div>
    </v-card>
    <ConcessionViewModal :concession="concession" />
    <ConcessionCancelModal :concession="concession" @refresh="$emit('refresh')" />
  </div>
</template>

<script>
import moment from "moment";
import ConcessionViewModal from "./ConcessionViewModal.vue";
import ConcessionCancelModal from "./ConcessionCancelModal.vue";

export default {
  name: "ConcessionViewController",
  components: {
    ConcessionViewModal,
    ConcessionCancelModal,
  },
  props: {
    concession: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: null,
    },
  },

  computed: {
    state() {
      if (!this.concession) {
        return {
          title:
            "Você ainda não enviou para análise nenhuma solicitação de meia entrada.",
          description:
            "Envie o documento que comprove seu direito a meia entrada.",
          canApply: true,
        };
      }

      if (this.concession.status === "MANUAL_REVIEW")
        return {
          title: "Solicitação em revisão manual",
          description:
            "Sua solicitação está em revisão manual. Quando o resultado estiver disponível, você receberá um e-mail com o resultado.",
          canViewRequest: true,
          canRevoke: true,
        };
      if (this.concession.status === "PENDING")
        return {
          title: "Solicitação em análise",
          description:
            "Sua solicitação está em análise. Quando o resultado estiver disponível, você receberá um e-mail com o resultado.",
          canViewRequest: true,
          canRevoke: false,
        };
      if (this.concession.status === "REJECTED")
        return {
          title: "Solicitação rejeitada",
          description:
            "Sua solicitação foi rejeitada. Você pode enviar uma nova solicitação.",
          canViewRequest: true,
          canApply: true,
        };
      if (this.concession.status === "REVOKED")
        return {
          title: "Solicitação cancelada",
          description:
            "Sua solicitação foi cancelada. Você pode enviar uma nova solicitação.",
          canApply: true,
        };
      if (this.concession.status === "APPROVED") {
        if (
          !this.concession.expiresAt ||
          moment(this.concession.expiresAt).isAfter(moment())
        )
          return {
            title: "Solicitação aprovada",
            description: `Você já pode usar o benefício. ${
              this.concession.expiresAt
                ? `Expira em ${moment(this.concession.expiresAt).format(
                    "DD/MM/YYYY"
                  )}`
                : ""
            }`,
            canRevoke: true,
          };
        else
          return {
            title: "Solicitação expirada",
            description:
              "Sua solicitação expirou. Você pode enviar uma nova solicitação.",
            canApply: true,
          };
      }
    },

    canApply() {
      return (
        !this.concession ||
        ["REJECTED", "REVOKED"].includes(this.concession.status)
      );
    },
  },
};
</script>
